<template>
<div class="chapter">
<div class="inner_page">
<div> <a id="author"></a></div>
<p class="center" style="font-size: 120%; margin-top: 15%">J<span class="sc">ESS</span> S<span class="sc">MITH</span></p>
<p class="textbreak">was raised in a large family of Scottish travellers. She is married with three children and six grandchildren. As a traditional storyteller, she is in great demand for live
  performances throughout Scotland. This is the first book in her autobiographical trilogy, which continues with <i>Tales from the Tent</i> and concludes with <i>Tears for a Tinker.</i> She has also
  written a novel, <i>Bruar’s Rest</i>, and a collection of stories for young readers, <i>Sookin’ Berries.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002_author.vue?73cc60c3